export default {
  menu: "Menu",
  nav1: {
    title: "Products",
    itemTitle1: "SIP DESK PHONES",
    item11: "Halo Series",
    item12: "Myriad Series",
    item13: "Cloud Edition",
    item14: "Conference phone",
    item15: "Headsets",
    item16: "Accessories",
    itemTitle2: "HEADSETS",
    item21: "Aries 11",
    item22: "Aries 12",
    item23: "Aries 21",
    item24: "Aries 22",
    item25: "Aries 20 II",
    itemTitle3: "ACCESSORIES",
    item31: "EM20",
    item32: "EM200",
    item33: "EHS300",
    item34: "Wall Mounting Kit",
    itemTitle4: "TOOLS",
    item41: "EDS",
    item42: "EDM",
  },
  nav2: {
    title: "Solutions",
    item1: "Hosted VoIP Solution",
    item2: "IP Contact Center Solution",
    item3: "Public Utilities Solution",
    item4: "Hospitality Solution",
  },
  nav3: {
    title: "Partners",
    item1: "Technical Partners",
    item2: "Become Our Partner",
    item3: "Become Our Partner",
    item4: "Become Our Partner",
  },
  nav4: {
    title: "Support",
    item1: "FAQ",
    item2: "Download Center",
    item3: "Feedback",
  },
  nav5: {
    title: "Company",
    item1: "About us",
    item2: "News and Events",
  },
};
